module.exports = __webpack_public_path__ + "static/media/icon-download.1dcd6e5b.svg";